import {useQueries} from '@tanstack/react-query'
import {getSubCategoryList} from '@/services/SubCategoryService/subCategory'

export const useSubCategoryList = (isEnabled = true) => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['SUB_CATEGORY_LIST'],
        queryFn: getSubCategoryList,
        enabled: isEnabled,
      },
    ],
  })

  return {
    subCategoryListData: results?.[0]?.data || [],
    isLoading: results?.[0]?.isLoading || false,
  }
} 